// extracted by mini-css-extract-plugin
export default {"list":"styles_list__1gtXz","listIconSixActive":"styles_listIconSixActive__y-vBh","item":"styles_item__luOuk","no":"styles_no__3SHoB"};